import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParamsUrlService {

  getParams(route) {
    route.queryParams.subscribe(params => {
      let url = params['url'];
      if (url !== undefined) {
        window.open(`${url}`, '_self');
        return;
      }
    });
  }
}
